
import { mapGetters } from "vuex";
import CatalogList from "@/components/common/CatalogList.vue";
import { metaGenerator } from "@/utils";
import useEvents from "~/mixins/useEvents";

export default {
  components: {
    CatalogList,
  },
  mixins: [useEvents],
  async asyncData({ error, $api, route, store }) {
    const getCollection = async () => {
      try {
        const { data } = await $api.products.getCollectionBySlug(
          route.params.slug
        );
        return data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
        error({ statusCode: err?.response?.status });
      }
    };
    await store.dispatch("general/fetchCollectionList");
    const splitedPath = route.path.split("/");
    const collectionsList = store.state.general.collectionList || [];
    const currentCollection = collectionsList.find(
      (el) => el.slug === route.params.slug
    );
    return {
      collectionData: await getCollection(),
      currentCollection,
    };
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({
      addSeoAttributes: {
        // TODO remove after reindex
        canonicalQueries:
          Number(this.$route.query.page) === 1 ? false : ["page"],
      },
    });
    let titleTemplate = `%s | ${this.getCompanyName}`;

    if (this.$route.query.page > 1) {
      titleTemplate += ` | ${this.$t("page")} ${this.$route.query.page}`;
    }
    let description = this.collectionData?.mixedTranslation?.meta_description || "";
   
      if (this.$route.query.page > 1) {
      description += ` ${this.$t("page")} ${this.$route.query.page}`;
    }
    return {
      meta: [
        ...metaGenerator({
          title:
            this.collectionData?.mixedTranslation?.meta_title ||
            this.collectionData?.mixedTranslation?.title ||
            "",
          description,
          image:
            this.collectionData?.medias?.find(
              (el) => el.position === "open-graph"
            )?.file?.url || "",
          url:
            this.collectionData?.meta_url ||
            process.env.DOMAIN + this.$route.fullPath,
          company_name: this.getCompanyName,
          titleTemplate,
        }),
        ...i18nHead.meta,
      ],
      htmlAttrs: i18nHead.htmlAttrs,
      link: i18nHead.link,
      title:
        this.collectionData?.mixedTranslation?.meta_title ||
        this.collectionData?.mixedTranslation?.title ||
        "",
      titleTemplate,
    };
  },
  computed: {
    ...mapGetters({
      getCompanyName: "general/getCompanyName",
    }),
    image() {
      return (
        this.collectionData?.medias?.find((el) => el.position === "page") || ""
      );
    },
    mobileImage() {
      return (
        this.collectionData?.medias?.find(
          (el) => el.position === "page-mobile"
        ) || ""
      );
    },
  },
  mounted() {
    this.visitEvent(true);
  },
  methods: {
    fetchData(page) {
      this.currentPage = page;
    },
  },
};
